import React from 'react';

const AriaLoader: React.FC = ({ children }) => (
  <p className="is-sr-only">{children || 'Loading content'}</p>
);

export default AriaLoader;
